/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultFlowMetaResponse } from '../../models/api-response-paged-result-flow-meta-response';
import { PagedRequestFlowMetaResponsesSearchReq } from '../../models/paged-request-flow-meta-responses-search-req';

export interface GetFlowMetaResponses$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestFlowMetaResponsesSearchReq
}

export function getFlowMetaResponses(http: HttpClient, rootUrl: string, params: GetFlowMetaResponses$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultFlowMetaResponse>> {
  const rb = new RequestBuilder(rootUrl, getFlowMetaResponses.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultFlowMetaResponse>;
    })
  );
}

getFlowMetaResponses.PATH = '/v1/api/ui/flow-meta/responses';
